import { render, staticRenderFns } from "./EmpresaCadastro.vue?vue&type=template&id=22ae1bee"
import script from "./EmpresaCadastro.vue?vue&type=script&lang=js"
export * from "./EmpresaCadastro.vue?vue&type=script&lang=js"
import style0 from "./EmpresaCadastro.vue?vue&type=style&index=0&id=22ae1bee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports